(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/views/systemspel.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/views/systemspel.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.maltipset.views.Systemspel = Backbone.Marionette.View.extend({
    template: function(data) {
      return svs.maltipset.templates.systemspel(data);
    },
    className: 'padding-1 padding-bottom-0',
    ui: {
      listElement: '.js-system-type li'
    },
    events: {
      'click @ui.listElement': 'onSystemTypeClick',
      'click .js-help-dialog-r-system': 'helpDialogRSystem',
      'click .js-help-dialog-m-system': 'helpDialogMSystem'
    },
    initialize: function() {
      this.originalSystem = this.model.get('system');
      this.selectedSystem = this.model.get('system');
      this.changed = false;
    },
    onSystemTypeClick: function(e) {
      this.selectedSystem = $(e.currentTarget).data('system');
      this.ui.listElement.removeClass('maltipset-system-type-active');
      $(e.currentTarget).addClass('maltipset-system-type-active');
      this.changed = this.originalSystem !== this.selectedSystem;
    },

    helpDialogRSystem: function(e) {
      if (svs.maltipset.data.config.helpTexts) {
        var _dialog = new svs.components.dialog.Contextual({
          branding: svs.components.dialog.branding.SPORT,
          attachTo: $(e.currentTarget),
          zIndex: 1400,
          title: svs.maltipset.data.config.helpTexts.r_system.title,
          message: [
            {
              type: svs.components.dialog.message.TEXT,
              text: svs.maltipset.data.config.helpTexts.r_system.body
            }
          ]
        });
        svs.components.dialog.api.add(_dialog);
      }
      e.stopPropagation();
    },

    helpDialogMSystem: function(e) {
      if (svs.maltipset.data.config.helpTexts) {
        var _dialog = new svs.components.dialog.Contextual({
          branding: svs.components.dialog.branding.SPORT,
          attachTo: $(e.currentTarget),
          zIndex: 1400,
          title: svs.maltipset.data.config.helpTexts.m_system.title,
          message: [
            {
              type: svs.components.dialog.message.TEXT,
              text: svs.maltipset.data.config.helpTexts.m_system.body
            }
          ]
        });
        svs.components.dialog.api.add(_dialog);
        e.stopPropagation();
      }
    }
  });
})(Backbone, _, svs);

 })(window);